/**
 * CARTO basemap URL'leri.
 * Key: VUE_APP_CARTO_API_KEY (frontend/.env.local veya Docker build-arg)
 * https://carto.com/basemaps/apikey
 *
 * Raster: rastertiles/ yolu + ?key= (eski light_all/ yolu filigranlı döner)
 * Vector: positron = light_all, dark-matter = dark_all
 */

const CARTO_API_KEY = (
  typeof process !== "undefined" && process.env?.VUE_APP_CARTO_API_KEY
    ? process.env.VUE_APP_CARTO_API_KEY
    : ""
).trim();

export function withCartoKey(url) {
  if (!CARTO_API_KEY) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}key=${encodeURIComponent(CARTO_API_KEY)}`;
}

export const CARTO_TILE_ATTR =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

/** Leaflet — light (eski light_all karşılığı) */
export const CARTO_RASTER_LIGHT_URL = withCartoKey(
  "https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png"
);

/** Leaflet — dark */
export const CARTO_RASTER_DARK_URL = withCartoKey(
  "https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}{r}.png"
);

/** MapLibre raster (Leaflet dışı fallback) */
export function cartoLightRasterTiles() {
  return ["a", "b", "c", "d"].map((s) =>
    withCartoKey(
      `https://${s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png`
    )
  );
}

/** MapLibre vector — GTFS / Storyboard (filigransız, önerilen) */
export const CARTO_VECTOR_POSITRON_STYLE_URL = withCartoKey(
  "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
);

export const CARTO_VECTOR_DARK_STYLE_URL = withCartoKey(
  "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json"
);
